"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./styles.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function overflowMenu(_ref) {
  var _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      children = _ref.children,
      _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "" : _ref$heading,
      _ref$toggleMenu = _ref.toggleMenu,
      toggleMenu = _ref$toggleMenu === void 0 ? function () {} : _ref$toggleMenu,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("overflow-menu", {
      open: isOpen
    })
  }, children, /*#__PURE__*/_react.default.createElement("ul", {
    className: "overflow-menu-items"
  }, heading !== "" && /*#__PURE__*/_react.default.createElement("li", {
    className: "overflow-menu-items-heading"
  }, heading), items.map(function (item, key) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: key
    }, item);
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "overflow-menu-backdrop",
    onClick: toggleMenu
  }));
}

overflowMenu.propTypes = {
  isOpen: _propTypes.default.bool,
  toggleMenu: _propTypes.default.func,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  heading: _propTypes.default.string,
  items: _propTypes.default.array
};
var _default = overflowMenu;
exports.default = _default;